import { render, staticRenderFns } from "./MyActivity.vue?vue&type=template&id=b20eebf8&scoped=true&"
import script from "./MyActivity.vue?vue&type=script&lang=js&"
export * from "./MyActivity.vue?vue&type=script&lang=js&"
import style0 from "./MyActivity.vue?vue&type=style&index=0&id=b20eebf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20eebf8",
  null
  
)

export default component.exports